import { ThemeToggle } from "./ThemeToggle";

export interface ITopNavigationItem {
  name: string;
  onClick: () => void;
  current?: boolean;
  utility?: boolean;
}

export function TopNavigation({
  items,
  user,
  onBrandClick,
}: {
  items: ITopNavigationItem[];
  user?: string;
  onBrandClick?: () => void;
}) {
  const pages = items.filter((i) => !i.utility);
  const utilities = items.filter((i) => i.utility);

  return (
    <header className="topbar">
      <div className="topbar-inner">
        <button className="brand" onClick={onBrandClick} aria-label="sgreg0r">
          sgreg<span className="zero">0</span>r
        </button>

        <nav className="nav" aria-label="pages">
          {pages.map((item, i) => (
            <button
              key={item.name}
              onClick={item.onClick}
              className={`nav-link${item.current ? " is-current" : ""}`}
              aria-current={item.current ? "page" : undefined}
            >
              <span className="nav-idx">{String(i + 1).padStart(2, "0")}</span>
              {item.name}
            </button>
          ))}
        </nav>

        <div className="topbar-side">
          {user && (
            <span className="user-tag" title="signed in">
              {user.toLowerCase()}
            </span>
          )}
          {utilities.map((item) => (
            <button
              key={item.name}
              onClick={item.onClick}
              className={`nav-link utility${item.current ? " is-current" : ""}`}
              aria-current={item.current ? "page" : undefined}
            >
              {item.name}
            </button>
          ))}
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
